/*
 * Code generated by Speakeasy (https://speakeasy.com). DO NOT EDIT.
 */

import * as z from "zod/v3";
import { remap as remap$ } from "../../lib/primitives.js";
import { safeParse } from "../../lib/schemas.js";
import { Result as SafeParseResult } from "../../types/fp.js";
import { SDKValidationError } from "../errors/sdkvalidationerror.js";

export type ListGuardrailsPoliciesRequest = {
  /**
   * Optional external end-user identifier forwarded by the API gateway.
   */
  xOnBehalfOf?: string | undefined;
};

/** @internal */
export const ListGuardrailsPoliciesRequest$inboundSchema: z.ZodType<
  ListGuardrailsPoliciesRequest,
  z.ZodTypeDef,
  unknown
> = z.object({
  "X-On-Behalf-Of": z.string().optional(),
}).transform((v) => {
  return remap$(v, {
    "X-On-Behalf-Of": "xOnBehalfOf",
  });
});
/** @internal */
export type ListGuardrailsPoliciesRequest$Outbound = {
  "X-On-Behalf-Of"?: string | undefined;
};

/** @internal */
export const ListGuardrailsPoliciesRequest$outboundSchema: z.ZodType<
  ListGuardrailsPoliciesRequest$Outbound,
  z.ZodTypeDef,
  ListGuardrailsPoliciesRequest
> = z.object({
  xOnBehalfOf: z.string().optional(),
}).transform((v) => {
  return remap$(v, {
    xOnBehalfOf: "X-On-Behalf-Of",
  });
});

export function listGuardrailsPoliciesRequestToJSON(
  listGuardrailsPoliciesRequest: ListGuardrailsPoliciesRequest,
): string {
  return JSON.stringify(
    ListGuardrailsPoliciesRequest$outboundSchema.parse(
      listGuardrailsPoliciesRequest,
    ),
  );
}
export function listGuardrailsPoliciesRequestFromJSON(
  jsonString: string,
): SafeParseResult<ListGuardrailsPoliciesRequest, SDKValidationError> {
  return safeParse(
    jsonString,
    (x) => ListGuardrailsPoliciesRequest$inboundSchema.parse(JSON.parse(x)),
    `Failed to parse 'ListGuardrailsPoliciesRequest' from JSON`,
  );
}
